module.exports = __webpack_public_path__ + "static/media/characters.a36caf06.png";